import utils from '@/app/utils/utils';
import { nextTick, watch, type Ref } from 'vue';

/**
 * Focuses on the provided HTML element, when the dependency ref has a truthy value.
 * The purpose is to improve accessibility with screen readers.
 * @param refToWatch Ref to watch. E.g. a Vue Query data object with is undefined by default until it's asynchronously fetched.
 * @param element  HTML element where a focus is set after the watched data is available.
 */
export function useFocusWithWatch(refToWatch: Ref, elementToFocus: Ref<HTMLElement | null, HTMLElement | null>) {
  watch(
    () => refToWatch.value,
    (newVal, oldVal) => {
      if (!oldVal && newVal) {
        void nextTick(() => {
          utils.setFocusForAccessibility(elementToFocus.value as HTMLElement);
        });
      }
    },
    { immediate: true }
  );
}
